// global
import React, { useState, useEffect, memo } from 'react';
import PropTypes from 'prop-types';
// api
import { listHealthProfessionAssociationUF } from 'app/api/healthProfessionAssociationUF';
// views
import CustomDropdown from 'app/components/commons/dropdown/CustomDropdown';
import ErrorLabel from 'app/components/commons/label/ErrorLabel';

function HealthProfessionAssociationUFDropdown(props) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    listHealthProfessionAssociationUF()
      .then(response => {
        const healthProfessionAssociationsUF = response.map(uf => {
          return {
            text: `${uf.initials}`,
            value: uf.id
          };
        });

        setOptions([{ text: '-', value: null }, ...healthProfessionAssociationsUF]);
      })
      .catch(setOptions([]));
  }, []);

  const {
    width,
    value,
    onChange,
    required,
    showLabel = true,
    isForm = true,
    error,
    styleName,
    placeholder = 'Selecionar UF',
    label = 'UF',
    ...rest
  } = props;

  return (
    <CustomDropdown
      placeholder={placeholder}
      label={showLabel && <ErrorLabel label={label} error={error} />}
      selection
      required={required}
      isForm={isForm}
      width={width}
      options={options}
      value={value}
      onChange={onChange}
      searchable={true}
      error={error}
      styleName={styleName}
      {...rest}
    />
  );
}

HealthProfessionAssociationUFDropdown.propTypes = {
  width: PropTypes.number,
  value: PropTypes.any,
  onChange: PropTypes.func,
  showLabel: PropTypes.bool,
  isForm: PropTypes.bool,
  error: PropTypes.bool,
  required: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  styleName: PropTypes.string
};

export default memo(HealthProfessionAssociationUFDropdown);
